module.exports = __webpack_public_path__ + "static/media/ringtone.ffb82888.jpg";